import { render } from "./BookingApp.vue?vue&type=template&id=54f05a7f"
import script from "./BookingApp.vue?vue&type=script&lang=js"
export * from "./BookingApp.vue?vue&type=script&lang=js"

import "./BookingApp.vue?vue&type=style&index=0&id=54f05a7f&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__